"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = require("@emotion/react");

var _theme = _interopRequireWildcard(require("../../theme/theme"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Button = function Button(_ref) {
  var className = _ref.className,
      children = _ref.children,
      onClick = _ref.onClick,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "button" : _ref$type,
      _ref$iconStart = _ref.iconStart,
      iconStart = _ref$iconStart === void 0 ? null : _ref$iconStart,
      _ref$iconEnd = _ref.iconEnd,
      iconEnd = _ref$iconEnd === void 0 ? null : _ref$iconEnd,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "regular" : _ref$size,
      _ref$fluid = _ref.fluid,
      fluid = _ref$fluid === void 0 ? false : _ref$fluid,
      _ref$isIcon = _ref.isIcon,
      isIcon = _ref$isIcon === void 0 ? false : _ref$isIcon;
  var paddingY = _theme["default"].spaceThreeQuarters;
  var paddingX = _theme["default"].spaceOneAndHalf;
  var fontSize = _theme["default"].fontSizeN;

  if (size === "small") {
    fontSize = _theme["default"].fontSizeM;
    paddingY = _theme["default"].spaceHalf;
    paddingX = _theme["default"].spaceThreeQuarters;
  }

  if (size === "big") {
    fontSize = _theme["default"].fontSizeL;
    paddingY = _theme["default"].spaceOne;
    paddingX = _theme["default"].spaceTwo;
  }

  if (isIcon) {
    paddingX = paddingY;
  }

  return (0, _react.jsx)("button", {
    className: className,
    css: (0, _react.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        appearance: none;\n\n        box-sizing: border-box;\n        height: calc(\n          ", " * 2 + ", " * ", " + 2 *\n            ", "\n        );\n        padding: ", " ", ";\n        width: ", ";\n\n        border: ", " solid ", ";\n        border-radius: ", ";\n\n        background: ", ";\n        color: ", ";\n\n        text-transform: uppercase;\n        white-space: nowrap;\n        font-family: ", ";\n        font-size: ", ";\n        line-height: ", ";\n\n        cursor: pointer;\n        transition: all 0.15s;\n        user-select: none;\n\n        @media (hover: hover) {\n          &:hover:not([disabled]) {\n            filter: brightness(1.2);\n          }\n        }\n\n        &:active:not([disabled]) {\n          filter: contrast(0.8);\n          transform: translateY(1px);\n        }\n\n        &:nth-of-type(n + 2) {\n          margin-left: ", ";\n        }\n\n        &[disabled] {\n          cursor: default;\n          opacity: 0.5;\n        }\n      "])), paddingY, fontSize, _theme["default"].lineHeightN, _theme["default"].borderSizeRegular, paddingY, paddingX, fluid ? "100%" : isIcon ? "calc(".concat(paddingX, " * 2 + ").concat(fontSize, " * ").concat(_theme["default"].lineHeightN, " + 2 * ").concat(_theme["default"].borderSizeRegular, ")") : "auto", _theme["default"].borderSizeRegular, _theme["default"].colorDarkTemp, _theme["default"].radiusRegular, _theme["default"].colorThemeTemp, _theme["default"].colorDarkTemp, _theme["default"].fontFamily, fontSize, _theme["default"].lineHeightN, _theme["default"].spaceOne),
    onClick: onClick,
    type: type,
    disabled: disabled
  }, iconStart && (0, _react.jsx)("span", {
    css: (0, _react.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n            margin-right: ", ";\n            line-height: 0;\n            display: inline-flex;\n            vertical-align: middle;\n          "])), _theme["default"].spaceThreeQuarters)
  }, iconStart), (0, _react.jsx)("span", {
    css: (0, _react.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n          ", "\n        "])), isIcon && "vertical-align: text-top;")
  }, children), iconEnd && (0, _react.jsx)("span", {
    css: (0, _react.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n            margin-left: ", ";\n            line-height: 0;\n            display: inline-flex;\n            vertical-align: middle;\n          "])), _theme["default"].spaceThreeQuarters)
  }, iconEnd));
};

Button.propTypes = {
  className: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired,
  disabled: _propTypes["default"].bool,
  type: _propTypes["default"].oneOf(_theme.INPUT_TYPES),
  iconStart: _propTypes["default"].node,
  iconEnd: _propTypes["default"].node,
  size: _propTypes["default"].oneOf(_theme.SIZES_TYPES),
  fluid: _propTypes["default"].bool,
  isIcon: _propTypes["default"].bool,
  onClick: _propTypes["default"].func
};
var _default = Button;
exports["default"] = _default;